import CloseIcon from '@mui/icons-material/Close';
import { Card, Drawer, IconButton, Stack } from '@mui/material';
import React, { ReactElement } from 'react';
import { useTheme } from 'styled-components';

const DEFAULT_DRAWER_WIDTH = 600;

interface InfoDrawerProps {
    cycle: any;
    open: boolean;
    onClose: () => void;
    children: ReactElement[];
    width?: number | string;
}

const InfoDrawer: React.FC<InfoDrawerProps> = ({ cycle, children, open, onClose, width = DEFAULT_DRAWER_WIDTH }) => {
    const theme = useTheme();

    return (
        <Drawer
            sx={{
                width: width,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: width, boxSizing: 'border-box' },
            }}
            anchor={"right"}
            open={open}
            onClose={onClose}
        >
            <Card sx={{ overflow: "auto", position: "relative" }}>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: theme.spacing(2),
                        right: theme.spacing(2),
                        zIndex: 1,
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Stack sx={{ padding: theme.spacing(4) }} gap={2}>
                    {children}
                </Stack>
            </Card>
        </Drawer>
    );
};

export default InfoDrawer;
